import styles from '@ui/components/Card/Card.module.scss';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { stripNonHtmlProps } from '@ui/utils';

const Card = forwardRef(
  (
    {
      as: Tag = 'div',
      children = null,
      className = null,
      hasAction = false,
      theme = 'default',
      ...props
    },
    ref,
  ) => (
    <Tag
      className={classNames(
        styles.container,
        styles[theme],
        {
          [styles.block]: Tag !== 'div',
          [styles.action]: hasAction,
        },
        className,
      )}
      ref={ref}
      {...stripNonHtmlProps(props)}
    >
      {children}
    </Tag>
  ),
);

Card.propTypes = {
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  hasAction: PropTypes.bool,
  theme: PropTypes.oneOf(['default', 'highlight', 'contrast']),
};

Card.displayName = 'Card';

export default Card;
